import { useMemo } from 'react';

import { autoConnectNodes, resolveConnectors } from './spiderweb-utils';

import type {
	ConnectorShape,
	ConnectorType,
	ResolvedConnector,
	WebConnectorConfig,
	WebNodeConfig,
} from './spiderweb-types';

export function useSpiderWebConnectorPlan(
	nodes: WebNodeConfig[],
	maxNeighbors: number,
	explicitConnectors: WebConnectorConfig[] | undefined,
	useOnlyExplicitConnectors: boolean,
	connectorShape: ConnectorShape,
	connectorType: ConnectorType,
): {
	connectorConfigs: WebConnectorConfig[];
	resolvedConnectors: ResolvedConnector[];
} {
	const connectorConfigs = useMemo(
		() =>
			explicitConnectors && useOnlyExplicitConnectors
				? explicitConnectors
				: autoConnectNodes(nodes, maxNeighbors, explicitConnectors),
		[nodes, maxNeighbors, explicitConnectors, useOnlyExplicitConnectors],
	);

	const resolvedConnectors = useMemo(
		() => resolveConnectors(connectorConfigs, nodes, connectorShape, connectorType),
		[connectorConfigs, nodes, connectorShape, connectorType],
	);

	return { connectorConfigs, resolvedConnectors };
}
